import React from 'react';

const LandingPage = ({ onEnter }) => {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat grayscale"
      style={{
        backgroundImage: 'url("/img/bg.jpg")',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-black/50" /> {/* Overlay for better text visibility */}
      
      <button
        onClick={onEnter}
        className="relative px-8 py-4 text-white border border-white/50 rounded-lg 
                   hover:border-white hover:bg-white/10 transition-all duration-300
                   font-mono tracking-wider"
      >
        <span className="relative z-10">ENTER.</span>
      </button>
    </div>
  );
};

export default LandingPage;